export const fontStyles = theme => ({
    [theme.breakpoints.down('sm')]: {
        fontSize: 11.5
    },
    [theme.breakpoints.up('md')]: {
        fontSize: 14
    }
});
